
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'ホーム' },
    { path: '/inventory', label: '在庫一覧' },
    { path: '/store', label: '店舗情報' },
    { path: '/contact', label: 'お問い合わせ' }
  ];

  return (
    <header className="bg-gradient-to-r from-purple-900 via-pink-800 to-orange-700 shadow-2xl sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* ロゴ */}
          <Link to="/" className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg">
              <img 
                src="https://static.readdy.ai/image/c4130dd04170239584b63226598adce4/c838132f9231b1e7231c776032e1a5f5.png" 
                alt="紳士服のミッキー ロゴ" 
                className="w-10 h-10 object-contain"
              />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-white" style={{ fontFamily: '"Pacifico", serif' }}>
                紳士服のミッキー
              </h1>
              <p className="text-xs text-pink-200">足利市で50年</p>
            </div>
          </Link>

          {/* デスクトップナビゲーション */}
          <nav className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-white font-semibold hover:text-yellow-300 transition-colors duration-300 relative ${
                  location.pathname === item.path ? 'text-yellow-300' : ''
                }`}
              >
                {item.label}
                {location.pathname === item.path && (
                  <div className="absolute -bottom-1 left-0 right-0 h-0.5 bg-yellow-300 rounded-full"></div>
                )}
              </Link>
            ))}
          </nav>

          {/* モバイルメニューボタン */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white p-2"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* モバイルメニュー */}
        {isMenuOpen && (
          <div className="md:hidden bg-purple-800 rounded-lg mt-2 mb-4 shadow-xl">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block px-6 py-4 text-white hover:bg-purple-700 transition-colors duration-300 ${
                  location.pathname === item.path ? 'bg-purple-700 text-yellow-300' : ''
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}
